import ShowroomDownloadsEdit from "./showroom-downloads-edit";

export default ShowroomDownloadsEdit;